import { authFetch, BASE_BACKEND_URL } from '../auth'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ErrorView from '../components/ErrorView'
import LoadingScreen from '../components/LoadingScreen'
import ShowChargeView from './ShowChargeView'

const ShowChargeApp = () => {
  const { id } = useParams()

  const [isFetching, setIsFetching] = useState(true)
  const [details, setDetails] = useState(null)
  const [defaultDetails, setDefaultDetails] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (id) fetchTransactionDetails()
  }, [id])

  const fetchTransactionDetails = () => {
    setIsFetching(true)

    authFetch(`${BASE_BACKEND_URL}/charges/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        if (response.status === 404) {
          return { error: true, message: 'No se encontró el cobro' }
        }
        return response.json()
      })
      .then((data) => {
        if (data.error) {
          setError(data.message)
        } else {
          setDetails(data)
          setDefaultDetails(data)
        }
        setIsFetching(false)
      })
      .catch((e) => console.error(e))
  }

  const handleSearch = (event, isEditing) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      const query = event.target.value
      if (query !== '') {
        const confirmation =
          isEditing &&
          !window.confirm(
            '¿Está seguro que quiere continuar? Los cambios editados no serán guardados.'
          )
        if (!confirmation) {
          window.location = `/pedidos?query=${query}`
        }
        event.target.value = ''
      }
    }
  }

  if (isFetching) {
    return <LoadingScreen text="Cargando..." />
  }

  if (error) {
    return <ErrorView error={error} />
  }

  return (
    <ShowChargeView
      details={details}
      position={id}
      defaultDetails={defaultDetails}
    />
  )
}

export default ShowChargeApp
